export default __webpack_public_path__ + "static/media/schoolDate2.1097965d.png";